import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { initSound, playTone, setVibeKey, setWorkDay } from "./sound";

const istDay = () => { const n = new Date(Date.now() + (330 + new Date().getTimezoneOffset()) * 60000); return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, "0")}-${String(n.getDate()).padStart(2, "0")}`; };

/** Screenshots / screen recording: blocked for everyone except the CEO (Android FLAG_SECURE via MainActivity bridge; web: no image save/long-press). */
export const applySecure = (me) => {
  const secure = !me?.is_ceo;
  try { window.NxcSecure?.setSecure(secure); } catch {}
  document.documentElement.classList.toggle("nxc-secure", secure);
  if (me?.prefs?.vibe) setVibeKey(me.prefs.vibe);
};
import { api, TOKEN_KEY } from "./api";
import { syncPush } from "./push";

const Ctx = createContext(null);

export function ConnectAuthProvider({ children }) {
  const [me, setMe] = useState(undefined);
  const [badges, setBadges] = useState({});
  const prevBadges = useRef(null);

  const refreshBadges = useCallback(async () => {
    try {
      const { data } = await api.get("/badges");
      const prev = prevBadges.current;
      if (prev) {
        if ((data.inbox || 0) > (prev.inbox || 0) || (data.ceo_chats || 0) > (prev.ceo_chats || 0)) playTone("ceo");
        else if ((data.chats || 0) > (prev.chats || 0) || (data.notifications || 0) > (prev.notifications || 0)) playTone("message");
        else if ((data.group_at && data.group_at !== prev.group_at) || (data.dept_at && data.dept_at !== prev.dept_at)) playTone("message");
      }
      prevBadges.current = data;
      setBadges(data);
      if (data.perms) setMe((m) => (m && JSON.stringify(m.perms) !== JSON.stringify(data.perms) ? { ...m, perms: data.perms, access: data.access } : m));
    } catch (_) {}
  }, []);

  useEffect(() => {
    initSound();
    const block = (e) => { if (document.documentElement.classList.contains("nxc-secure")) e.preventDefault(); };
    document.addEventListener("contextmenu", block);
    return () => document.removeEventListener("contextmenu", block);
  }, []);
  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) { setMe(null); return; }
    api.get("/me").then((r) => { setMe(r.data); applySecure(r.data); setWorkDay(r.data.working_today ? istDay() : ""); }).catch(() => { localStorage.removeItem(TOKEN_KEY); setMe(null); });
  }, []);

  useEffect(() => {
    if (!me) return;
    if (localStorage.getItem("nxc_push_off") !== "1") syncPush();
    refreshBadges();
    const t = setInterval(refreshBadges, 15000);
    return () => clearInterval(t);
  }, [me, refreshBadges]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setMe(data.me);
    applySecure(data.me);
    api.get("/me").then((r) => { setMe(r.data); setWorkDay(r.data.working_today ? istDay() : ""); }).catch(() => {});
  };
  const logout = () => { api.post("/auth/logout").catch(() => {}); localStorage.removeItem(TOKEN_KEY); setMe(null); };

  return <Ctx.Provider value={{ me, login, logout, badges, refreshBadges }}>{children}</Ctx.Provider>;
}

export const useConnect = () => useContext(Ctx);
